<template>
	<div class="content" v-if="!zhanlanDetail">
		<div class="main_zhanlan">
			<div class="m">
				<div class="main_moment">
					<div class="video" v-if="MomentList.length > 0">
						<div class="swiper mySwiper2">
							<div class="swiper-wrapper">
								<div class="swiper-slide" v-for="(v, i) in MomentList" :key="v.uuid">
									<video v-if="v.contentType === 2" playsinline webkit-playsinline @click="videoFn(v)" :src="v.videoUrl" ref="videoPlay" :poster="v.coverUrl + '?x-image-process=image/resize,w_1200,limit_0'" controls="controls">
										您的浏览器不支持 video 标签。
									</video>
									<img class="slide-img" v-else-if="v.contentType === 3" @click="outLink(v)" :src="v.coverUrl + '?x-image-process=image/resize,w_1200,limit_0'" alt="">
									<img class="slide-img" v-else-if="v.contentType === 1" @click="toDetail(v)" :src="v.coverUrl + '?x-image-process=image/resize,w_1200,limit_0'" alt="">
								</div>

							</div>
						</div>
						<div class="swiper-pagination" v-if="MomentList.length > 1"></div>
					</div>
					<div class="right">
						<div class="right1">
							<scrollText reverse></scrollText>
						</div>
						<div class="right2">
							{{ En ? 'Show Introduction' : '展会介绍' }}
						</div>
						<div class="right3" v-if="MomentList[activeIndex]">
							{{ MomentList[activeIndex]['blurb' + En] }}
						</div>
						<div class="btns">
							<div class="btn" @click="profileFn">
								{{ $t('newbanner6') }}
								<img class="img1" src="https://obs-gociif.ciif-expo.com/ciif/static/images/new/right-black.png" alt="">
								<img class="img2" src="https://obs-gociif.ciif-expo.com/ciif/static/images/new/right-white.png" alt="">
							</div>
						</div>
					</div>
				</div>
				<!-- banner -->
				<div class="slide_pic" v-if="BannerList.length > 0">
					<!--<div class="btn prev" @click="prev"></div>
					<div class="btn next" @click="next"></div>-->
					<div class="swiper mySwiper">
						<div class="swiper-wrapper">
							<div class="swiper-slide" v-for="(v, i) in BannerList" :key="v.uuid">
								<img :src="v['coverUrl' + En] + '?x-image-process=image/resize,w_800,limit_0'" class="pic" @click="outLink(v)" />
							</div>
						</div>
						<div class="dot" v-if="BannerList.length != 1">
							<div v-for="(v, i) in BannerList" @click="swiperTo(i)" :style="{ background: current == i?ExhibitDetail.themeColor:'' }"></div>
						</div>
					</div>
				</div>
				<!-- 新闻列表 -->
				<div class="main_newss" v-if="NewsList.length > 0">
					<div class="tong_title">
						<span>{{$t('zhanlannews')}}</span>
						<div class="btns">
							<div class="btn" @click="newFn">
								{{ $t('newbanner6') }}
								<img class="img1" src="https://obs-gociif.ciif-expo.com/ciif/static/images/new/right-black.png" alt="">
								<img class="img2" src="https://obs-gociif.ciif-expo.com/ciif/static/images/new/right-white.png" alt="">
							</div>
						</div>
					</div>
					<div class="box">
						<!-- <div class="btn prev" @click="prev1"></div>
						<div class="btn next" @click="next1"></div> -->
						<div class="swiper1-container">
							<div class="swiper mySwiper1" :class="isPc ? 'swiper-pc' : ''">
								<div class="swiper-wrapper">
									<div class="swiper-slide" v-for="(v, i) in NewsList" :key="v.uuid">
										<div class="bg" :style="{ background: ExhibitDetail.themeColor }"></div>
										<div class="label" @click="openDetail(v)">
											<p class="p">
												<big>{{ v['name' + En] }}</big>
											</p>
											<div class="topBlurb">{{ v['topBlurb' + En] }}</div>
											<img class="right-icon" src="https://obs-gociif.ciif-expo.com/ciif/static/images/new/right-black.png" alt="">
											<div class="time">
												<img src="https://obs-gociif.ciif-expo.com/ciif/static/images/new/time-icon.png" />
												<em>{{ sliceStr(v.releaseTime) }}</em>
												<div class="space"></div>
												<img v-if="v['source' + En]" src="https://obs-gociif.ciif-expo.com/ciif/static/images/new/link-icon.png" />
												<em v-if="v['source' + En]">{{ En ? 'Source：' : '来源：' }}{{ v['source' + En] }}</em>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<!-- 知名展商 -->
				<div class="main_showlist" v-if="ExhibitionList.length > 0">
					<div class="tong_title">
						<span>{{$t('zhanlanzs')}}</span>
					</div>
					<div class="slidebox" v-if="ExhibitionList.length">
						<vue-seamless-scroll :data="ExhibitionList" ref='seamless' class="seamless-warp" :class-option="defaultOption" v-if="isPc">
							<div class="sw">
								<!-- <a v-for="(v, i) in ExhibitionList" :key="v.uuid" :href="v.linkUrl" target="_blank">
									<img :src="v.coverUrl" />
								</a> -->
								<a v-for="(v, i) in ExhibitionList" @click="zsFn(v)" :style="'background-image: url('+ v.coverUrl +')'" :key="v.uuid" :href="v.linkUrl" target="_blank">
									<!-- <img :src="v.coverUrl" /> -->
								</a>
							</div>
						</vue-seamless-scroll>
						<template v-else>
							<a v-for="(v, i) in ExhibitionList" @click="zsFn(v)" :style="'background-image: url('+ v.coverUrl +')'" :key="v.uuid" :href="v.linkUrl" target="_blank">
								<!-- <img :src="v.coverUrl" /> -->
							</a>
						</template>
					</div>
					<!--<ul>
						<li>
							<a :href="v.linkUrl" target="_blank">
								<img :src="v.coverUrl" />
							</a>
						</li>
					</ul>-->
				</div>
				<div class="main_showlist" v-if="ExhibitMediaList.length > 0">
					<div class="tong_title">
						<span>{{$t('zhanlanzs1')}}</span>
					</div>
					<!--<div class="swiper mySwiper6">
						<div class="swiper-wrapper">
							<div class="swiper-slide" v-for="(v, i) in ExhibitMediaList" :key="v.uuid">
								<a :href="v.linkUrl" target="_blank">
									<img :src="v.coverUrl" />
								</a>
							</div>
						</div>
					</div>-->
					<div class="slidebox" v-if="ExhibitMediaList.length">
						<vue-seamless-scroll :data="ExhibitMediaList" ref='seamless1' class="seamless-warp" :class-option="defaultOption" v-if="isPc">
							<div class="sw">
								<a v-for="(v, i) in ExhibitMediaList" @click="mediaFn(v)" :style="'background-image: url('+ v.coverUrl +')'" :key="v.uuid" :href="v.linkUrl" target="_blank">
									<!-- <img :src="v.coverUrl" /> -->
								</a>
							</div>
						</vue-seamless-scroll>
						<template v-else>
							<a v-for="(v, i) in ExhibitMediaList" @click="mediaFn(v)" :style="'background-image: url('+ v.coverUrl +')'" :key="v.uuid" :href="v.linkUrl" target="_blank"></a>
						</template>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import protal from "@/api/li";
	export default {
		name: 'zhanlan',
		data() {
			return {
				activeIndex: 0,
				current: 0,
				flagtop: false,
				day: "",
				hour: "", //倒计时  小时
				minute: "", // 倒计时 分钟
				seconds: "", //倒计时 秒
				interval: "",
				countdownTime: 0,
				arrs: [],
				uuid: '',
				ExhibitDetail: {},
				MomentList: [],
				NewsList: [],
				BannerList: [],
				ExhibitionList: [],
				ExhibitMediaList: [],
				FunctionModule: [],
				zhanlanDetail: localStorage.getItem('zhanlanDetail'),
				blackTabPages: ['/ias', '/rs', '/stis'], // tab为黑色的页面
			}
		},
		created() {
			this.uuid = window.zhanlanRoute.filter(x => x[1] === this.$route.name)[0][0] || window.localStorage.getItem('uuid')
			window.localStorage.setItem('uuid', this.uuid)
			this.getMeetingTime()
			this.getQueryExhibitDetail()
		},
		mounted() {
			this.$store.commit('setLeftIndex', '首页')
			this.$store.commit('setHeadIndex', 0)
			window.addEventListener('scroll', this.handleScroll)
		},
		computed: {

			defaultOption() {
				return {
					step: 0.4, // 数值越大速度滚动越快
					          limitMoveNum: 1, // 开始无缝滚动的数据量 this.dataList.length
					          hoverStop: true, // 是否开启鼠标悬停stop
					          direction: 2, // 0向下 1向上 2向左 3向右
					          openWatch: true, // 开启数据实时监控刷新dom
					          singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
					          singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
					          waitTime: 1000 // 单步运动停止的时间(默认值1000ms)
				}
			}
		},
		methods: {
			newFn() {
				this.$router.push('/news_publish?pageType=exhibitNews&uuid=' + this.uuid)
			},
			videoFn(v) {
				this.$jsAPI('track', 'ciif_gbzyExhibitionHome_video', {
					contentID_var: v.uuid,
					contentName_var: v.videoUrl,
					exhibitionName_var: this.ExhibitDetail.name,
				})
			},
			toDetail(v) {
				this.$router.push(`match_process?pageType=momentDetail&uuid=${v.uuid}`)
			},
			outLink(v) {
				this.$jsAPI('track', 'ciif_gbzyExhibitionHome_banner', {
					contentID_var: v.uuid,
					contentName_var: v.coverUrl,
					exhibitionName_var: this.ExhibitDetail.name,
				})
				if (v.linkUrl) {
					window.open(v.linkUrl)
				}
			},
			swiperTo(n) {
				this.swiper.slideTo(n + 1)
			},
			mediaFn(v) {
				this.$jsAPI('track', 'ciif_gbzyExhibitionHome_meitiList', {
					contentName_var: v.coverUrl,
					exhibitionName_var: this.ExhibitDetail.name
				})
			},
			zsFn(v) {
				this.$jsAPI('track', 'ciif_gbzyExhibitionHome_exList', {
					contentName_var: v.coverUrl,
					exhibitionName_var: this.ExhibitDetail.name
				})
			},
			profileFn() {
				this.openLink({
					link: '/match_process?code=exhibition_introduction' + '&pageType=exhibitPage'
				}, 0)
			},
			// 点击一级菜单
			openLink(v, i) {
				if(v.link) {
					// this.$store.commit('setHeadIndex', i)
					if(v.query) {
						this.$router.push({
							path: v.link,
							query: { ...v.query
							}
						})
					} else {
						this.$router.push({
							path: v.link
						})
					}
				}
			},
			// 打开详情页
			openDetail(v) {
				this.$jsAPI('track', 'ciif_gbzyExhibitionHome_newList', {
					contentName_var: v.name,
					exhibitionName_var: this.ExhibitDetail.name
				})
				this.$store.commit('setPageName', {
					name: '新闻详情',
					nameEn: 'News Details',
				})
				this.openMatch({
					path: '/match_process',
					query: {
						pageType: 'exhibitNew',
						uuid: v.uuid
					}
				}, v)
			},
			// 官网查询专业展信息
			getQueryExhibitDetail() {
				let that = this;
				protal.getQueryExhibitDetail(this.uuid).then(r => {
					this.$store.commit('setHeadIndex', 0)
					this.$store.commit('setExhibitDetail', r.data)
					this.ExhibitDetail = r.data
					this.pageView('ciif_gbzyExhibitionHome', { exhibitionName_var: this.ExhibitDetail.name })
					if (this.zhanlanDetail) {
						this.$router.push(this.zhanlanDetail)
						localStorage.setItem('zhanlanDetail', '')
					}
				})
				// 官网查询专业展精彩瞬间列表
				protal.getWebMomentList({
					"exhibitUuid": this.uuid,
					"pageNum": 1,
					"pageSize": 9999
				}).then(r => {
					this.MomentList = r.data
					if (this.MomentList.length > 1) {
						const that = this
						this.$nextTick(() => {
							this.swiper2 = new Swiper('.mySwiper2', {
								loop: true,
								autoplay: 3000,
								slidesPerView: "auto",
								speed: 600, // 滑动速度
								pagination: '.swiper-pagination',
								onTransitionEnd: function (swiper) {
									that.activeIndex = swiper.activeIndex
								},
							})
						})
					}
				})
				// 官网查询专业展精彩瞬间列表
				protal.getExhibitionFunctionModule(this.uuid).then(r => {
					this.$store.commit('setFunctionModule', r.data)
					this.FunctionModule = r.data
				})
				// 官网查询专业展新闻
				protal.getExhibitNewsList({
					"exhibitUuid": this.uuid,
					"pageNum": 1,
					"pageSize": 10,
					"topSts": 0
				}).then(r => {
					this.NewsList = r.data
					console.log(this.NewsList, 3333)
					this.$nextTick(() => {
						if(this.isPc) {
							this.swiper1 = new Swiper('.mySwiper1', {
								loop: true,
								slidesPerView: 3,
								spaceBetween: 22,
								autoplay: 3000,
								speed: 600, // 滑动速度
								autoplayDisableOnInteraction: false
							})
						} else {
						}
					})
				})
				// 官网查询专业展banner
				protal.getExhibitBannerList({
					"exhibitUuid": this.uuid,
					"pageNum": 1,
					"pageSize": 9999
				}).then(r => {
					this.BannerList = r.data
					let that = this
					this.$nextTick(() => {
						this.swiper = new Swiper('.mySwiper', {
							//							loop: true,
							autoplay: 3000,
							speed: 600,
							onTransitionStart: function(swiper) {
								that.current = swiper.realIndex
							},
							autoplayDisableOnInteraction: false

						})
					})
				})
				// 官网查询专业展知名展商
				protal.getExhibitExhibitionList({
					"exhibitUuid": this.uuid,
					"pageNum": 1,
					"pageSize": 9999
				}).then(r => {
					this.ExhibitionList = r.data
					setTimeout(() => {
						this.$refs.seamless._initMove()
					}, 500)

				})
				// 官网查询专业展合作媒体
				protal.getExhibitMediaList({
					"exhibitUuid": this.uuid,
					"pageNum": 1,
					"pageSize": 9999
				}).then(r => {
					this.ExhibitMediaList = r.data
					setTimeout(() => {
						this.$refs.seamless1._initMove()
					}, 500)
				})
			},
			// 官网查询大会倒计时
			getMeetingTime() {
				protal.getMeetingTime().then(r => {
					this.countdownTime = (r.data.endTime - r.data.currTime)
					// this.setTimeData(r.endTime - r.currTime);
					this.payCountdown(this.countdownTime)
				})
			},
			setTimeData(cm) {
				this.day = Math.floor((cm / 1000 / 60 / 60));
				this.day = this.day.toString().length == 1 ? "0" + this.day : this.day;
				this.hour = Math.floor((cm / 1000 / 60 / 60) % 24);
				this.hour =
					this.hour.toString().length == 1 ? "0" + this.hour : this.hour;
				this.minute = Math.floor((cm / 1000 / 60) % 60);
				this.minute =
					this.minute.toString().length == 1 ? "0" + this.minute : this.minute;
				this.seconds = Math.floor((cm / 1000) % 60);
				this.seconds =
					this.seconds.toString().length == 1 ?
					"0" + this.seconds :
					this.seconds;
			},
			setTimer() {
				let _this = this;
				this.interval = setInterval(function() {
					_this.payCountdown(_this.countdownTime * 60 * 1000);
					clearInterval(_this.interval);
				}, 1000);
			},
			payCountdown(cm) {
				let _this = this;
				if(cm >= 0) {
					this.day = Math.floor(cm / (1000 * 60 * 60 * 24));
					this.day = this.day.toString().length == 1 ? "0" + this.day : this.day;
					this.hour = Math.floor((cm % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
					this.hour =
						this.hour.toString().length == 1 ? "0" + this.hour : this.hour;
					this.minute = Math.floor((cm % (1000 * 60 * 60)) / (1000 * 60));
					this.minute =
						this.minute.toString().length == 1 ?
						"0" + this.minute :
						this.minute;
					this.seconds = Math.floor((cm % (1000 * 60)) / 1000);
					this.seconds =
						this.seconds.toString().length == 1 ?
						"0" + this.seconds :
						this.seconds;
					let _msThis = this;

					this.arrs[0] = String(this.day).slice(0, 1)
					this.arrs[1] = String(this.day).slice(1, 2)
					this.arrs[2] = String(this.hour).slice(0, 1)
					this.arrs[3] = String(this.hour).slice(1, 2)
					this.arrs[4] = String(this.minute).slice(0, 1)
					this.arrs[5] = String(this.minute).slice(1, 2)
					this.arrs[6] = String(this.seconds).slice(0, 1)
					this.arrs[7] = String(this.seconds).slice(1, 2)
					this.arrs[8] = String(this.day).slice(2, 3)
					this.arrs = this.arrs.filter(x => x).map((item) => {
						return require(`@/assets/images/time${item}.png`)
					})
					this.$forceUpdate()
					setTimeout(function() {
						cm -= 1000;
						_msThis.payCountdown(cm);
					}, 1000);
				}
			},
			handleScroll() {
				let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
				if(scrollTop > 100) {
					this.flagtop = true
				} else {
					this.flagtop = false
				}
			},
			beforeDestroy() {
				window.removeEventListener('scroll', this.handleScroll)
			},
			changeLang() {
				let locale = this.$i18n.locale;
				locale === "ch" ? (this.$i18n.locale = "en") : (this.$i18n.locale = "ch");
				localStorage.setItem("lang", this.$i18n.locale);
			},
			prev() {
				this.swiper.slidePrev()
			},
			next() {
				this.swiper.slideNext()
			},
			prev1() {
				this.swiper1.slidePrev()
			},
			next1() {
				this.swiper1.slideNext()
			},
			prev2() {
				this.swiper2.slidePrev()
			},
			next2() {
				this.swiper2.slideNext()
			},
		}
	}
</script>

<style lang="less" scoped>
@media screen and (min-width: 769px) {
	.seamless-warp {
		width: 100%;
		overflow: hidden;
		position: relative;
		overflow-y: auto;
	}
	
	.dot {
		display: flex;
		align-items: center;
		justify-content: center;
		position: absolute;
		left: 0;
		bottom: .12rem;
		width: 100%;
		z-index: 99999;
		div {
			width: .12rem;
			height: .12rem;
			cursor: pointer;
			border-radius: 50%;
			margin: 0 .06rem;
			background: rgba(255, 255, 255, 0.2);
			&.on {
				background: #005CA2;
			}
		}
	}

	.tong_title {
		padding-bottom: 28px;
		border-bottom: 1px solid rgba(11, 36, 63, 0.2);
		display: flex;
		justify-content: space-between;
		align-items: center;

		span {
			font-family: Inter, syn;
			font-weight: 600;
			font-size: 50px;
			color: #000000;
			line-height: 50px;
			text-align: left;
			font-style: normal;
		}

		.btns {
			display: flex;

			.btn {
				height: 56px;
				border: 1px solid rgba(11, 36, 63, 0.6);
				border-radius: 12px;
				font-family: MiSans, MiSans;
				font-weight: 500;
				font-size: 16px;
				color: #0B243F;
				line-height: 16px;
				text-align: left;
				font-style: normal;
				padding: 0 28px 0 20px;
				display: flex;
				align-items: center;
				justify-content: center;
				cursor: pointer;

				img {
					width: 24px;
					height: auto;
					margin-left: 12px;
					display: none;

					&.img1 {
						display: block;
					}

					&.img2 {
						display: none;
					}
				}

				&:hover {
					background-color: #F4501C;
					border-color: #F4501C;
					color: #fff;

					img {

						&.img1 {
							display: none;
						}

						&.img2 {
							display: block;
						}
					}
				}
			}
		}
	}
	
	.main_zhanlan {
		overflow: hidden;
		width: 100%;
		background-size: 100%;
		background-color: #F8F8F9;
		.m {
			width: 1640px;
			margin: 0 auto;
			margin-top: 100px;
			.main_showlist {
				overflow: hidden;
				width: 100%;
				margin-top: .8rem;
				margin-bottom: .8rem;
				.slidebox {
					display: flex;
					width: 100%;
					align-items: center;
					margin-top: 60px;
					.sw {
						display: flex;
						align-items: center;
						width: 100%;
						a {
							display: block;
							width: 2.37rem;
							height: .8rem;
							margin-right: .2rem;
							background-repeat: no-repeat;
							background-size: contain;
							background-position: center center;
							// filter: grayscale(100%);
							transition: all .2s;
							border-radius: 24px;
							overflow: hidden;
							&:hover {
								filter: grayscale(0%);
							}
						}
					}
					marquee {
						display: flex;
						align-items: center;
					}
				}
				.swiper {
					width: 100%;
					overflow: hidden;
					.swiper-wrapper {
						-webkit-transition-timing-function: linear !important;
						-moz-transition-timing-function: linear !important;
						-ms-transition-timing-function: linear !important;
						-o-transition-timing-function: linear !important;
						transition-timing-function: linear !important;
					}
					.swiper-slide {
						width: auto;
						margin-right: .2rem;
						img {
							height: .8rem;
							width: auto;
							// filter: grayscale(100%);
							transition: all .2s;
							&:hover {
								filter: grayscale(0%);
							}
						}
					}
				}
				ul {
					overflow: hidden;
					white-space: nowrap;
					overflow-x: scroll;
					&::-webkit-scrollbar {
						display: none;
					}
					li {
						overflow: hidden;
						margin: 0 .1rem;
						margin-top: .32rem;
						display: inline-block;
						img {
							display: block;
							width: auto;
							height: 0.8rem;
						}
					}
				}
			}
			.main_newss {
				margin-bottom: .8rem;

				.more {
					width: 1.28rem;
					height: .36rem;
					border-radius: .5rem;
					background: #005CA2;
					margin-right: .68rem;
					transition: all .1s;
					float: right;
					&:hover {
						opacity: 0.8;
					}
					a {
						width: 100%;
						height: 100%;
						display: flex;
						align-items: center;
						justify-content: center;
						font-size: .2rem;
						color: #fff;
						line-height: 1;
					}
				}
				.box {
					width: 100%;
					position: relative;
					height: 476px;
					margin-top: 48px;
					.btn {
						width: .4rem;
						height: .4rem;
						background-size: 100% 100%;
						position: absolute;
						top: 50%;
						transform: translateY(-50%);
						z-index: 999;
						cursor: pointer;
						&.prev {
							left: .16rem;
							background-image: url(../../assets/images/prev3.png);
							&:hover {
								background-image: url(../../assets/images/prev.png);
							}
						}
						&.next {
							right: .16rem;
							background-image: url(../../assets/images/next3.png);
							&:hover {
								background-image: url(../../assets/images/next.png);
							}
						}
					}
					.swiper1-container {
						width: 100%;
						height: 100%;
						overflow: hidden;
					}
					.swiper {
						width: 100%;
						height: 100%;
						overflow: hidden;
						.swiper-slide {
							position: relative;
							cursor: pointer;
							width: 532px;
							height: 476px;
							background: #FFFFFF;
							border-radius: 24px;

							.bg {
								position: absolute;
								left: 0;
								right: 0;
								top: 0;
								bottom: 0;
								border-radius: 24px;
								opacity: 0;
							}

							.label {
								position: relative;
								z-index: 1;
								padding: 36px 28px;

								div {
									display: flex;
									align-items: center;
									img {
										width: 22px;
										height: auto;
										margin-right: 6px;
									}
									em {
										font-family: Inter, syn;
										font-weight: 400;
										font-size: 20px;
										color: #5D5E5F;
										line-height: 20px;
										text-align: left;
										font-style: normal;
									}

									.space {
										margin-right: 40px;
									}
								}
								p {
									font-family: "syb";
									
									big {
										font-family: Inter, syn;
										font-weight: 600;
										font-size: 28px;
										color: #000000;
										line-height: 40px;
										height: 120px;
										text-align: left;
										font-style: normal;
										display: -webkit-box;
										-webkit-box-orient: vertical;
										-webkit-line-clamp: 3;
										overflow: hidden;
									}
								}
								.topBlurb {
									font-family: Inter, syn;
									font-weight: 400;
									font-size: 20px;
									color: #666666;
									line-height: 32px;
									height: 96px;
									text-align: left;
									font-style: normal;
									display: -webkit-box;
									-webkit-box-orient: vertical;
									-webkit-line-clamp: 3;
									overflow: hidden;
									/*max-height: 1.25rem;*/
									overflow: hidden;
								}

								.right-icon {
									margin: 60px 0;
									width: 42px;
									height: auto;
								}
							}

							&:hover {

								.bg {
									opacity: 1;
								}

								.label {

									.topBlurb {
										color: #000000;
									}
								}
							}
						}
					}
				}
			}
			.slide_pic {
				width: 100%;
				border-radius: .28rem;
				position: relative;
				overflow: hidden;
				margin-bottom: 120px;
				.btn {
					width: .4rem;
					height: .4rem;
					background-size: 100% 100%;
					position: absolute;
					top: 50%;
					transform: translateY(-50%);
					z-index: 999;
					cursor: pointer;
					&.prev {
						left: .16rem;
						background-image: url(../../assets/images/prev1.png);
						&:hover {
							background-image: url(../../assets/images/prev.png);
						}
					}
					&.next {
						right: .16rem;
						background-image: url(../../assets/images/next1.png);
						&:hover {
							background-image: url(../../assets/images/next.png);
						}
					}
				}
				.pic {
					width: 100%;
					cursor: pointer;
				}
			}
			.main_moment {
				overflow: hidden;
				width: 100%;
				position: relative;
				padding-left: 1036px;
				min-height: 580px;
				margin-bottom: 100px;
				.video {
					width: 916px;
					height: 579px;
					border-radius: 24px;
					overflow: hidden;
					position: absolute;
					left: 0;
					top: 0;
					padding-top: 18px;
					border: 1px solid rgba(11, 36, 63, 0.2);
					background-color: #F3F4F5;

					.btn {
						width: .4rem;
						height: .4rem;
						background-size: 100% 100%;
						position: absolute;
						top: 50%;
						transform: translateY(-50%);
						z-index: 999;
						cursor: pointer;
						&.prev {
							left: .16rem;
							background-image: url(../../assets/images/prev1.png);
							&:hover {
								background-image: url(../../assets/images/prev.png);
							}
						}
						&.next {
							right: .16rem;
							background-image: url(../../assets/images/next1.png);
							&:hover {
								background-image: url(../../assets/images/next.png);
							}
						}
					}
					img {
						width: 1.6rem;
						position: absolute;
						cursor: pointer;
						z-index: 999;
						left: 50%;
						transform: translate(-50%, -50%);
						top: 50%;
					}
					video {
						width: 880px;
						height: 495px;
						border-radius: .28rem;
						object-fit: cover;
						margin: 0 auto;
						display: block;
					}

					.swiper-pagination {
						display: flex;
						justify-content: center;
						width: 100%;
						margin-top: 24px;

						/deep/ .swiper-pagination-bullet {
							margin: 0 8px;
							width: 10px;
							height: 10px;
							background-color: #C4CAD1;
							opacity: 1;

							&.swiper-pagination-bullet-active {
								background-color: #F4511E;
							}
						}
					}
				}
						
				.slide-img {
					width: 100% !important;
					height: 7.2rem !important;
					position: static !important;
					transform: translate(0, 0) !important;
				}

				.right {
					min-height: 600px;
					padding-top: 60px;
					position: relative;
					z-index: 1;

					.right1 {
						display: flex;
						align-items: center;
						font-family: MiSans, MiSans;
						font-weight: 600;
						font-size: 16px;
						color: #999999;
						line-height: 26px;
						text-align: left;
						font-style: normal;

						.icon {
							margin-left: 6px;
							width: 32px;
							height: auto;
						}
					}

					.right2 {
						font-family: Inter, syb;
						font-weight: 600;
						font-size: 48px;
						color: #0B243F;
						line-height: 52px;
						text-align: left;
						font-style: normal;
						margin: 60px 0 24px;
					}

					.right3 {
						font-family: Inter, syn;
						font-weight: 400;
						font-size: 20px;
						color: #666666;
						line-height: 32px;
						text-align: left;
						font-style: normal;
						margin-bottom: 48px;
					}

					.btns {
						display: flex;

						.btn {
							height: 56px;
							border: 1px solid rgba(11, 36, 63, 0.6);
							border-radius: 12px;
							font-family: MiSans, MiSans;
							font-weight: 500;
							font-size: 16px;
							color: #0B243F;
							line-height: 16px;
							text-align: left;
							font-style: normal;
							padding: 0 28px 0 20px;
							display: flex;
							align-items: center;
							justify-content: center;
							margin-right: 16px;
							cursor: pointer;

							img {
								width: 24px;
								height: auto;
								margin-left: 12px;
								display: none;

								&.img1 {
									display: block;
								}

								&.img2 {
									display: none;
								}
							}

							&:hover {
								background-color: #F4501C;
								border-color: #F4501C;
								color: #fff;

								img {

									&.img1 {
										display: none;
									}

									&.img2 {
										display: block;
									}
								}
							}
						}
					}
				}
			}
		}

		.zhanlan1 {
			height: 520px;
			background-color: #421C2F;
			position: relative;

			.left {
				position: absolute;
				left: 140px;
				top: 380px;
				display: flex;

				.item {
					margin-right: 100px;

					.text1 {
						
						span {
							font-family: MiSans, MiSans;
							font-weight: 400;
							font-size: 14px;
							color: #F4501C;
							line-height: 14px;
							text-align: left;
							font-style: normal;
							text-transform: uppercase;
							position: relative;
							display: inline-block;

							&::before {
								content: "";
								position: absolute;
								left: 0;
								right: 0;
								top: -5px;
								height: 1px;
								background: #F4501C;
								opacity: 0.8;
							}
						}
					}

					.text2 {
						margin: 8px 0;
						font-family: MiSans, MiSans;
						font-weight: 500;
						font-size: 24px;
						color: #fff;
						line-height: 24px;
						text-align: left;
						font-style: normal;
					}

					.text3 {
						font-family: MiSans, MiSans;
						font-weight: 400;
						font-size: 18px;
						color: #fff;
						line-height: 18px;
						text-align: left;
						font-style: normal;
					}
				}
			}

			.right {
				position: absolute;
				right: 140px;
				top: 180px;
				width: 240px;
				height: 240px;
				border-radius: 24px;
			}

			.text {
				position: absolute;
				left: 140px;
				top: 150px;
				font-family: syb;
				font-weight: 600;
				font-size: 72px;
				color: #FFFFFF;
				line-height: 80px;
				text-align: left;
				font-style: normal;
				text-transform: uppercase;
				position: relative;
				width: 1240px;
				
				.big {
					position: absolute;
					width: 100%;
					left: -140px;
					top: 14px;
					transform: scale(1.667);
					transform-origin: left top;
					color: rgba(255, 255, 255, 0.04);
					font-weight: bold;
				}

				&.text-en {
					font-family: Inter SemiBold;
				}
			}
		}

		.zhanlan2 {
			width: 100%;
			
			ul {
				width: 1640px;
				height: 100%;
				margin: 0 auto;
				display: flex;
				flex-wrap: wrap;
				align-items: center;
				padding: 9px 0;

				li {
					height: 44px;
					border-radius: 24px;
					border: 1px solid rgba(255, 255, 255, 0.4);
					font-family: Inter, syn;
					font-weight: 500;
					font-size: 22px;
					color: #fff;
					line-height: 22px;
					text-align: left;
					font-style: normal;
					padding: 0 22px;
					display: flex;
					align-items: center;
					justify-content: center;
					cursor: pointer;
					margin: 10px 0;
					margin-right: 8px;

					.text1 {
						display: none;
					}

					.text2 {
						display: inline;
					}

					&:hover, &.active {
						background-color: #fff;
						color: #fff;

						.text1 {
							display: inline;
						}

						.text2 {
							display: none;
						}
					}

					&.black {
						border-color: rgba(0, 0, 0, 0.2);
						color: #000;

						&:hover, &.active {
							background-color: #000;
							color: #fff;

							.text1 {
								display: none;
							}

							.text2 {
								display: inline;
							}
						}
					}
				}
			}
		}
	}
}
@media screen and (max-width: 768px) {
	.seamless-warp {
		width: 100%;
		overflow: hidden;
		position: relative;
		overflow-y: auto;
	}
	
	.dot {
		display: flex;
		align-items: center;
		justify-content: center;
		position: absolute;
		left: 0;
		bottom: .12rem;
		width: 100%;
		z-index: 99999;
		div {
			width: .12rem;
			height: .12rem;
			cursor: pointer;
			border-radius: 50%;
			margin: 0 .06rem;
			background: rgba(255, 255, 255, 0.2);
			&.on {
				background: #005CA2;
			}
		}
	}

	.tong_title {
		padding-bottom: .28rem;
		border-bottom: 1px solid rgba(11, 36, 63, 0.2);
		display: flex;
		justify-content: space-between;
		align-items: center;

		span {
			font-family: Inter, syb;
			font-size: .6rem;
			color: #000000;
			line-height: .6rem;
			text-align: left;
			font-style: normal;
		}

		.btns {
			display: flex;

			.btn {
				font-family: MiSans, MiSans;
				font-weight: 500;
				font-size: .24rem;
				color: #0B243F;
				line-height: .24rem;
				text-align: left;
				font-style: normal;
				display: flex;
				align-items: center;
				justify-content: center;
				cursor: pointer;

				img {
					width: .36rem;
					height: auto;
					margin-left: .12rem;
					display: none;

					&.img1 {
						display: block;
					}

					&.img2 {
						display: none;
					}
				}

				&:hover {
					background-color: #F4501C;
					border-color: #F4501C;
					color: #fff;

					img {

						&.img1 {
							display: none;
						}

						&.img2 {
							display: block;
						}
					}
				}
			}
		}
	}
	
	.main_zhanlan {
		overflow: hidden;
		width: 100%;
		background-size: 100%;
		background-color: #F8F8F9;
		.m {
			width: 6.78rem;
			margin: 0 auto;
			margin-top: 1rem;
			.main_showlist {
				overflow: hidden;
				width: 100%;
				margin-top: .8rem;
				margin-bottom: 1rem;
				.slidebox {
					display: flex;
					flex-wrap: wrap;
					width: 7.14rem;
					margin-top: .4rem;

					a {
						display: block;
						width: 2.12rem;
						height: 1.06rem;
						margin-right: .2rem;
						margin-bottom: .2rem;
						background-repeat: no-repeat;
						background-size: contain;
						background-position: center center;
						// filter: grayscale(100%);
						transition: all .2s;
						border-radius: .24rem;
						overflow: hidden;
						background-color: #fff;
						&:hover {
							filter: grayscale(0%);
						}
					}
				}
				.swiper {
					width: 100%;
					overflow: hidden;
					.swiper-wrapper {
						-webkit-transition-timing-function: linear !important;
						-moz-transition-timing-function: linear !important;
						-ms-transition-timing-function: linear !important;
						-o-transition-timing-function: linear !important;
						transition-timing-function: linear !important;
					}
					.swiper-slide {
						width: auto;
						margin-right: .2rem;
						img {
							height: .8rem;
							width: auto;
							// filter: grayscale(100%);
							transition: all .2s;
							&:hover {
								filter: grayscale(0%);
							}
						}
					}
				}
				ul {
					overflow: hidden;
					white-space: nowrap;
					overflow-x: scroll;
					&::-webkit-scrollbar {
						display: none;
					}
					li {
						overflow: hidden;
						margin: 0 .1rem;
						margin-top: .32rem;
						display: inline-block;
						img {
							display: block;
							width: auto;
							height: 0.8rem;
						}
					}
				}
			}
			.main_newss {
				margin-top: 1.2rem;

				.more {
					width: 1.28rem;
					height: .36rem;
					border-radius: .5rem;
					background: #005CA2;
					margin-right: .68rem;
					transition: all .1s;
					float: right;
					&:hover {
						opacity: 0.8;
					}
					a {
						width: 100%;
						height: 100%;
						display: flex;
						align-items: center;
						justify-content: center;
						font-size: .2rem;
						color: #fff;
						line-height: 1;
					}
				}
				.box {
					width: 100%;
					position: relative;
					margin-top: 48px;
					.btn {
						width: .4rem;
						height: .4rem;
						background-size: 100% 100%;
						position: absolute;
						top: 50%;
						transform: translateY(-50%);
						z-index: 999;
						cursor: pointer;
						&.prev {
							left: .16rem;
							background-image: url(../../assets/images/prev3.png);
							&:hover {
								background-image: url(../../assets/images/prev.png);
							}
						}
						&.next {
							right: .16rem;
							background-image: url(../../assets/images/next3.png);
							&:hover {
								background-image: url(../../assets/images/next.png);
							}
						}
					}
					.swiper1-container {
						width: 100%;
						height: 100%;
						overflow: hidden;
					}
					.swiper {
						width: 100%;
						height: 100%;
						overflow: hidden;

						.swiper-wrapper {
							display: block;
						}

						.swiper-slide {
							position: relative;
							cursor: pointer;
							width: 6.78rem;
							margin: 0 auto .2rem;
							background: #FFFFFF;
							border-radius: .28rem;
							padding: .36rem 0 .4rem;

							.bg {
								position: absolute;
								left: 0;
								right: 0;
								top: 0;
								bottom: 0;
								border-radius: 24px;
								opacity: 0;
							}

							.label {
								position: relative;
								z-index: 1;
								padding: 0 .28rem;

								div {
									display: flex;
									align-items: center;
									img {
										width: .26rem;
										height: auto;
										margin-right: .04rem;
										transform: translateY(-0.02rem);
									}
									em {
										font-family: Inter, syn;
										font-weight: 400;
										font-size: .24rem;
										color: #5D5E5F;
										line-height: .24rem;
										text-align: left;
										font-style: normal;
									}

									.space {
										margin-right: .28rem;
									}
								}
								p {
									font-family: "syb";
									
									big {
										font-family: Inter, syn;
										font-weight: 600;
										font-size: .28rem;
										color: #000000;
										line-height: .4rem;
										text-align: left;
										font-style: normal;
										display: -webkit-box;
										-webkit-box-orient: vertical;
										-webkit-line-clamp: 3;
										overflow: hidden;
									}
								}
								.topBlurb {
									font-family: Inter, syn;
									font-weight: 400;
									font-size: .24rem;
									color: #666666;
									line-height: .32rem;
									text-align: left;
									font-style: normal;
									margin-top: .2rem;
									display: -webkit-box;
									-webkit-box-orient: vertical;
									-webkit-line-clamp: 3;
									overflow: hidden;
									/*max-height: 1.25rem;*/
									overflow: hidden;
								}

								.right-icon {
									margin: .48rem 0;
									width: .48rem;
									height: auto;
								}
							}

							&:hover {

								.bg {
									opacity: 1;
								}

								.label {

									.topBlurb {
										color: #000000;
									}
								}
							}
						}
					}
				}
			}
			.slide_pic {
				width: 100%;
				border-radius: .28rem;
				position: relative;
				overflow: hidden;
				margin-bottom: 1.2rem;
				margin-top: 1rem;
				.btn {
					width: .4rem;
					height: .4rem;
					background-size: 100% 100%;
					position: absolute;
					top: 50%;
					transform: translateY(-50%);
					z-index: 999;
					cursor: pointer;
					&.prev {
						left: .16rem;
						background-image: url(../../assets/images/prev1.png);
						&:hover {
							background-image: url(../../assets/images/prev.png);
						}
					}
					&.next {
						right: .16rem;
						background-image: url(../../assets/images/next1.png);
						&:hover {
							background-image: url(../../assets/images/next.png);
						}
					}
				}
				.pic {
					width: 100%;
					height: 2.26rem;
					cursor: pointer;
					display: block;
				}
			}
			.main_moment {
				overflow: hidden;
				width: 100%;
				position: relative;
				.video {
					width: 6.78rem;
					border-radius: .28rem;
					overflow: hidden;
					padding-top: .18rem;
					padding-bottom: .18rem;
					border: 1px solid rgba(11, 36, 63, 0.2);
					background-color: #F3F4F5;

					/deep/ .swiper {
						width: 6.42rem;
						height: 3.61rem;
						margin: 0 auto;
						overflow: hidden;
					}

					.btn {
						width: .4rem;
						height: .4rem;
						background-size: 100% 100%;
						position: absolute;
						top: 50%;
						transform: translateY(-50%);
						z-index: 999;
						cursor: pointer;
						&.prev {
							left: .16rem;
							background-image: url(../../assets/images/prev1.png);
							&:hover {
								background-image: url(../../assets/images/prev.png);
							}
						}
						&.next {
							right: .16rem;
							background-image: url(../../assets/images/next1.png);
							&:hover {
								background-image: url(../../assets/images/next.png);
							}
						}
					}
					img {
						width: 1.6rem;
						position: absolute;
						cursor: pointer;
						z-index: 999;
						left: 50%;
						transform: translate(-50%, -50%);
						top: 50%;
					}
					video {
						width: 6.42rem;
						height: 3.61rem;
						border-radius: .28rem;
						object-fit: cover;
						margin: 0 auto;
						display: block;
					}

					.swiper-pagination {
						position: static;
						display: flex;
						justify-content: center;
						width: 100%;
						margin-top: .28rem;
						margin-bottom: .22rem;

						/deep/ .swiper-pagination-bullet {
							margin: 0 .1rem;
							width: .12rem;
							height: .12rem;
							background-color: #C4CAD1;
							opacity: 1;

							&.swiper-pagination-bullet-active {
								background-color: #F4511E;
							}
						}
					}
				}
						
				.slide-img {
					width: 100% !important;
					height: 7.2rem !important;
					position: static !important;
					transform: translate(0, 0) !important;
				}

				.right {
					padding-top: .46rem;
					position: relative;
					z-index: 1;

					.right1 {
						display: none;
					}

					.right2 {
						margin-bottom: .28rem;
						font-family: Inter, syb;
						font-size: .6rem;
						color: #0B243F;
						line-height: .6rem;
						text-align: left;
						font-style: normal;
					}

					.right3 {
						font-family: Inter, syn;
						font-weight: 400;
						font-size: .26rem;
						color: #666666;
						line-height: .4rem;
						text-align: left;
						font-style: normal;
						margin-bottom: .4rem;
					}

					.btns {
						display: flex;

						.btn {
							height: .88rem;
							border: 1px solid rgba(11, 36, 63, 0.6);
							border-radius: .2rem;
							font-family: MiSans, MiSans;
							font-weight: 500;
							font-size: .24rem;
							color: #0B243F;
							line-height: .24rem;
							text-align: left;
							font-style: normal;
							padding: 0 .28rem;
							display: flex;
							align-items: center;
							justify-content: center;
							cursor: pointer;

							img {
								width: .36rem;
								height: auto;
								margin-left: .12rem;
								display: none;

								&.img1 {
									display: block;
								}

								&.img2 {
									display: none;
								}
							}

							&:hover {
								background-color: #F4501C;
								border-color: #F4501C;
								color: #fff;

								img {

									&.img1 {
										display: none;
									}

									&.img2 {
										display: block;
									}
								}
							}
						}
					}
				}
			}
		}

		.zhanlan1 {
			height: 520px;
			background-color: #421C2F;
			position: relative;

			.left {
				position: absolute;
				left: 140px;
				top: 380px;
				display: flex;

				.item {
					margin-right: 100px;

					.text1 {
						
						span {
							font-family: MiSans, MiSans;
							font-weight: 400;
							font-size: 14px;
							color: #F4501C;
							line-height: 14px;
							text-align: left;
							font-style: normal;
							text-transform: uppercase;
							position: relative;
							display: inline-block;

							&::before {
								content: "";
								position: absolute;
								left: 0;
								right: 0;
								top: -5px;
								height: 1px;
								background: #F4501C;
								opacity: 0.8;
							}
						}
					}

					.text2 {
						margin: 8px 0;
						font-family: MiSans, MiSans;
						font-weight: 500;
						font-size: 24px;
						color: #fff;
						line-height: 24px;
						text-align: left;
						font-style: normal;
					}

					.text3 {
						font-family: MiSans, MiSans;
						font-weight: 400;
						font-size: 18px;
						color: #fff;
						line-height: 18px;
						text-align: left;
						font-style: normal;
					}
				}
			}

			.right {
				position: absolute;
				right: 140px;
				top: 180px;
				width: 240px;
				height: 240px;
				border-radius: 24px;
			}

			.text {
				position: absolute;
				left: 140px;
				top: 150px;
				font-family: syb;
				font-weight: 600;
				font-size: 72px;
				color: #FFFFFF;
				line-height: 80px;
				text-align: left;
				font-style: normal;
				text-transform: uppercase;
				position: relative;
				width: 1240px;
				
				.big {
					position: absolute;
					width: 100%;
					left: -140px;
					top: 14px;
					transform: scale(1.667);
					transform-origin: left top;
					color: rgba(255, 255, 255, 0.04);
					font-weight: bold;
				}

				&.text-en {
					font-family: Inter SemiBold;
				}
			}
		}

		.zhanlan2 {
			width: 100%;
			
			ul {
				width: 1640px;
				height: 100%;
				margin: 0 auto;
				display: flex;
				flex-wrap: wrap;
				align-items: center;
				padding: 9px 0;

				li {
					height: 44px;
					border-radius: 24px;
					border: 1px solid rgba(255, 255, 255, 0.4);
					font-family: Inter, syn;
					font-weight: 500;
					font-size: 22px;
					color: #fff;
					line-height: 22px;
					text-align: left;
					font-style: normal;
					padding: 0 22px;
					display: flex;
					align-items: center;
					justify-content: center;
					cursor: pointer;
					margin: 10px 0;
					margin-right: 8px;

					.text1 {
						display: none;
					}

					.text2 {
						display: inline;
					}

					&:hover, &.active {
						background-color: #fff;
						color: #fff;

						.text1 {
							display: inline;
						}

						.text2 {
							display: none;
						}
					}

					&.black {
						border-color: rgba(0, 0, 0, 0.2);
						color: #000;

						&:hover, &.active {
							background-color: #000;
							color: #fff;

							.text1 {
								display: none;
							}

							.text2 {
								display: inline;
							}
						}
					}
				}
			}
		}
	}
}
</style>


// WEBPACK FOOTER //
// src/pages/zhanlan/zhanlan.vue